module.exports = __webpack_public_path__ + "img/logo_twitter_color.1516422b.svg";